<template>
  <div>
    <nav class="navbar navbar-light header">
      <div>
        <a class="navbar-brand" href="https://www.labreferencia.com/">
          <img
            src="../assets/logo_ref.png"
            class="logo d-inline-block align-top"
            alt=""
            loading="lazy"
          />
        </a>
      </div>

      <div class="float-right d-flex">
        <div class="mr-4 d-flex align-items-center">
          <Menu :router="router" />
        </div>
        <div class="info">
          <div class="info__person">
            <p class="mb-0">¡{{ dia }} {{ user.firstName }}  {{ user.lastName }}!</p>
            <span class="pt-2">
              {{ timestamp }}
            </span>
          </div>

          <b-button variant="success" @click="signOff">
            Cerrar Sesión
          </b-button>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Menu from "./Menu";
import { mapState } from "vuex";
import SecureLS from "secure-ls";

export default {
  name: "Header",
  components: {
    Menu,
  },

  data() {
    return {
      nombre: "",
      timestamp: "",
      dia: "Saludos",
      ls: new SecureLS({ isCompression: false }),
      router: [
        {
          name: "Vacante",
          path: "/vacante",
          rolesView: ["SuperAdmin", "Admin"],
        },
        {
          name: "Usuarios",
          path: "/usuario",
          rolesView: ["SuperAdmin"],
        },
        {
          name: "Solicitudes",
          path: "/solicitudes",
          rolesView: ["SuperAdmin", "Admin"],
        },
        {
          name: "Solicitud",
          path: "/",
          rolesView: ["Solicitante"],
        },
        {
          name: "Contraseña",
          path: "/credenciales",
          rolesView: ["SuperAdmin", "Admin", "Solicitante"],
        },
      ],
    };
  },
  created() {
    setInterval(this.getNow, 1000);
  },

  methods: {
    getNow: function() {
      const today = new Date();
      const date =
        today.getDate() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getFullYear();
      const time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      const dateTime = date + " " + time;
      this.timestamp = dateTime;
    },
    async signOff() {
      this.$store
        .dispatch({
          type: "login/revokeToken",
          data: { token: this.$store.state.login.refreshToken },
        })
        .then(() => {
          this.ls.removeAll();
          this.$store.commit("login/RESETLOGIN");
          this.$router.push("/login");
        })
        .catch(() => {
          this.$swal.fire("Error", `No al momento de cerrar sesión`, "error");
        });
    },
  },
  computed: {
    CambiarDia() {
      const today = new Date();
      return this.today.getHours() > "12"
        ? (this.dia = "Buenas Tardes")
        : (this.dia = "Buenas Noche");
    },

    ...mapState({
      user: (state) => state.login.user,
    }),
  },
};
</script>

<style>
.header {
  background: #ffffff;
  border-bottom: 2px solid #28a745;
  -webkit-box-shadow: 0px 6px 8px -4px rgba(0, 0, 0, 0.34);
  -moz-box-shadow: 0px 6px 8px -4px rgba(0, 0, 0, 0.34);
  box-shadow: 0px 6px 8px -4px rgba(0, 0, 0, 0.34);
}
.letra {
  color: aliceblue;
}
.logo {
  width: 155px;
}

.info {
  display: flex;
}

.info__person {
  margin-right: 18px;
}
.info__person > p {
  color: #28a745;
  font-size: 0.9rem;
}
.info__person > span {
  text-align: right;
  color: #cacaca;
  font-size: 0.85rem;
}
</style>
